// components/modals/DeleteCodingFormModal.tsx
import React from 'react';
import ArrModal from '../../common/arr-modal/ArrModal';
import {
  useDeleteCodingForm,
  useCanDeleteCodingForm,
  useCopyCodingForm,
} from '../../../hooks/document/useDocument';
import {ICodingListGridData} from '../../../api/types/document.type';
import {ToastType} from '../../../shared/constants';
import {t} from 'i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedForm: ICodingListGridData | null;
  triggerToast: (message: string, status: ToastType[]) => void;
  refetchCodingFormList: () => void;
}

const DeleteCodingFormModal: React.FC<Props> = ({
  open,
  onClose,
  selectedForm,
  triggerToast,
  refetchCodingFormList,
}) => {
  const {mutate: deleteCodingForm, reset: resetDeleteCodingForm} =
    useDeleteCodingForm();
  const {reset: resetCanDeleteCodingForm} = useCanDeleteCodingForm();
  const {reset: resetCopyCodingForm} = useCopyCodingForm();
  const handleConfirmDelete = () => {
    resetDeleteCodingForm();
    resetCanDeleteCodingForm();
    resetCopyCodingForm();

    deleteCodingForm(selectedForm?.codingFormId ?? '', {
      onSuccess: (data) => {
        triggerToast(data.message, [ToastType.Success]);
        refetchCodingFormList();
        onClose();
      },
      onError: (data, error) => {
        triggerToast(data.message || error, [ToastType.Error]);
        onClose();
      },
    });
  };

  return (
    <ArrModal
      showModal={open}
      onClose={onClose}
      title={t('common.delete')}
      description={t('codingForms.manage.deleteText')}
      dataTestId="deletecoding-form-modal"
      buttons={[
        {
          id: '1',
          label: t('common.no'),
          onClick: onClose,
          variant: 'secondary',
          dataTestId: 'delete-modal-cancel-btn',
        },
        {
          id: '2',
          label: t('common.yes'),
          onClick: handleConfirmDelete,
          variant: 'primary',
          dataTestId: 'delete-modal-confirm-btn',
        },
      ]}
    />
  );
};

export default DeleteCodingFormModal;
